import React from 'react';
import styles from '../../../styles/index';
import { withStyles } from '@material-ui/core';
import combineStyles from '../../../styles/combineStyles';
import { buttonStyles } from '../../../styles/base';
import { Button } from '@material-ui/core';
import style from '../../../styles/sass/pages/Sell.module.scss';
import {
  CaretRight,
  MapPin,
  Money,
  Handshake,
  CheckCircle,
  XCircle,
} from 'phosphor-react';
import Reviews from '../home/Reviews';
import router from 'next/router';
import { connect } from 'react-redux';
import { formatUtmParams } from '../../../lib/helpers';
import { isMobile, isTablet } from '../../../lib/getDeviceSize';
import { schedulingLink } from '../../../lib/constants';

export interface Props {
  classes: any;
  utmCampaign: string;
  utmMedium: string;
  utmSource: string;
  utmTerm: string;
}

const TYPEFORM_LINK = 'https://form.typeform.com/to/VZUDv6HY';

export class SellPage extends React.Component<Props> {
  render() {
    const { classes } = this.props;
    const utmParams = formatUtmParams(this.props);
    return (
      <React.Fragment>
        {/* Section Hero */}
        <section
          className={`col-xs-12 home-hero-banner sell-page-hero ${classes.homeBg}`}
        >
          <div className="home-hero">
            <h2 className="home-hero-heading-text">
              Looking to sell your home? Find sure ground at Torii in a shifting
              real estate market.
            </h2>
            <React.Fragment>
              <p className="home-hero-text home-hero-text-sell-page">
                Get a free home value estimate to get started.
              </p>
            </React.Fragment>
            <div className={style.buttonContainer}>
              <Button
                variant="contained"
                className={`${style.largeButton} ${style.estimateButton}`}
                classes={{ label: classes.socialLabel }}
                size="large"
                onClick={() => {
                  window.open(`${TYPEFORM_LINK}${utmParams}`, '_blank');
                }}
              >
                Get Estimate
              </Button>
              <Button
                variant="contained"
                className={`${style.largeButton} ${style.talkButton}`}
                classes={{ label: classes.socialLabel }}
                size="large"
                onClick={() => {
                  window.open(`${schedulingLink}${utmParams}`, '_blank');
                }}
              >
                Talk to us{' '}
                <CaretRight size={22} color="#ff7350" weight="regular" />
              </Button>
            </div>
            <div className="hero-location">
              <MapPin
                size={22}
                color="#FFFFFF"
                weight="fill"
                style={{ marginRight: 5 }}
              />
              <p style={{ color: '#FFFFFF' }}>
                Available across all of Massachusetts
              </p>
            </div>
            <div className="home-hero-image sell-hero-image">
              <img
                className="home-hero-image-two sell-hero-image-desktop"
                alt="sell-hero-image-desktop"
                src="/static/img/landing_pages/sell-hero-desktop.png"
              />
              <img
                className="home-hero-image-two sell-hero-image-tablet"
                alt="sell-hero-image-tablet"
                src="/static/img/landing_pages/sell-hero-tablet.png"
              />
              <img
                className="home-hero-image-two sell-hero-image-mobile"
                alt="sell-hero-image-mobile"
                src="/static/img/landing_pages/sell-hero-mobile.png"
              />
            </div>
          </div>
          <article className="press-container press-container-sell-page">
            <img
              src="/static/img/home/business-insider-logo.svg"
              className="press-icon press-icon-sell-page"
              alt="Business-Insider"
            />
            <img
              src="/static/img/home/boston-globe-logo.svg"
              className="press-icon press-icon-sell-page"
              alt="Boston-Globe"
            />
            <img
              src="/static/img/home/inman-logo.svg"
              className="press-icon press-icon-sell-page"
              alt="Inman"
            />
          </article>
        </section>
        <img
          src="/static/img/home/hero-bottom-ellipse.svg"
          className="bottom-ellipse bottom-ellipse-desktop-tablet"
        />
        <img
          src="/static/img/home/hero-bottom-ellipse-mobile.svg"
          className="bottom-ellipse bottom-ellipse-mobile"
        />

        {/* Section Advantage */}
        <section className="col-xs-12 center-xs middle-xs advantage home-advantage">
          <div
            className="col-xs-12 advantage-home-container"
            style={{ flexDirection: 'column' }}
          >
            <div className="advantage-header advantage-header-sell-page">
              <span className="advantage-heading">
                Better Agents. <br className="mobile-only" />
                Real savings.
              </span>
            </div>
            <div className="advantage-points">
              <div
                className="advantage-point-container"
                style={{ backgroundColor: '#463264' }}
              >
                <Money size={90} color="#BA779C" weight="duotone" />
                <h4
                  className="advantage-point-heading"
                  style={{ color: '#fff' }}
                >
                  Affordable listing fee
                </h4>
                <span className="advantage-point-text">
                  Real estate commissions are too damn high so we cut ours down
                  considerably and give it back to you. Up to thousands of
                  dollars in savings you won't find anywhere else. Treat
                  yourself!
                </span>
              </div>
              <div
                className="advantage-point-container"
                style={{ backgroundColor: '#195A50' }}
              >
                <Handshake size={90} color="#FFD750" weight="duotone" />
                <h4
                  className="advantage-point-heading"
                  style={{ color: '#fff' }}
                >
                  Expert local agents
                </h4>
                <span className="advantage-point-text">
                  When you sell your home with Torii, our local real estate
                  agents are with you every step of the way. Our team of experts
                  will negotiate with buyers, and make sure you get the best
                  price possible.
                </span>
              </div>
              <div
                className="advantage-point-container"
                style={{ backgroundColor: '#822841' }}
              >
                <img src="/static/img/landing_pages/for-sale-icon.png" />
                <h4
                  className="advantage-point-heading"
                  style={{ color: '#fff', margin: '8px 0px 20px 0px' }}
                >
                  Full marketing package
                </h4>
                <span className="advantage-point-text">
                  We’ll make sure your home is the talk of the town with
                  professional photos, a video walkthrough, 3D home tour,
                  dedicated marketing, and is displayed across every major real
                  estate platform.
                </span>
              </div>
            </div>
            <div className="blue-blob no-tablet no-mobile" />
            <div className="yellow-blob no-tablet no-mobile" />
            <div className="pink-blob no-tablet no-mobile" />
            <div
              className="advantage-header"
              style={{ margin: '80px 0px 0px', justifyContent: 'center' }}
            >
              <span className="advantage-heading">How it works</span>
            </div>
            <div className={style.number}>
              <span>1</span>
            </div>
            <div className={style.howItWorksHeading}>
              <span>
                Get your home value <br className="no-tablet no-mobile" />{' '}
                estimate
              </span>
            </div>
            <div className={style.howItWorksDetails}>
              <span>
                Send us the address of the home you{' '}
                <br className="no-tablet no-mobile" /> want to sell and we’ll
                send you our free <br className="no-tablet no-mobile" /> home
                value estimate and develop a{' '}
                <br className="no-tablet no-mobile" /> competitive strategy to
                sell your home.
              </span>
            </div>
            <div className={style.number}>
              <span>2</span>
            </div>
            <div className={style.howItWorksHeading}>
              <span>
                List your property <br className="no-tablet no-mobile" /> for
                sale
              </span>
            </div>
            <div className={style.howItWorksDetails}>
              <span>
                When you're ready to sell, we’ll turn on{' '}
                <br className="no-tablet no-mobile" /> the marketing magic.
                Professional <br className="no-tablet no-mobile" /> photos, a
                video walkthrough, 3D home{' '}
                <br className="no-tablet no-mobile" /> tour, dedicated
                marketing, and is displayed{' '}
                <br className="no-tablet no-mobile" /> across every major real
                estate platform.
              </span>
            </div>
            <div className={style.number}>
              <span>3</span>
            </div>
            <div className={style.howItWorksHeading}>
              <span>
                Sell your home and <br className="no-tablet no-mobile" /> save
                thousands
              </span>
            </div>
            <div className={style.howItWorksDetails}>
              <span>
                Your expert Torii agent will vet potential{' '}
                <br className="no-tablet no-mobile" /> buyers, negotiate
                incoming offers, and <br className="no-tablet no-mobile" />{' '}
                advise you every step of the way so{' '}
                <br className="no-tablet no-mobile" /> you get the price your
                home deserves.
              </span>
            </div>
          </div>
        </section>

        {/* Section Reasoning */}
        <section
          className="col-xs-12 reasoning"
          style={{ backgroundColor: '#faf5f0' }}
        >
          <div className="reasoning-container">
            <h1>Why Torii?</h1>
            <article className="reasons">
              <div
                className="reason"
                style={{
                  margin: '20px 0px 0px 0px',
                  backgroundColor: 'transparent',
                }}
              >
                <span className="reason-text no-mobile">&nbsp;</span>
                <h6 className="column-one">Torii</h6>
                <h6 className="column-two no-desktop">Others</h6>
                <h6 className="column-two no-mobile no-tablet">
                  Traditional Brokerage
                </h6>
              </div>
              <div className="reason">
                <span className="reason-text">
                  Highly-vetted real estate agents
                </span>
                <span className="column-one">
                  <CheckCircle size={24} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={24} color="#822841" weight="fill" />
                </span>
              </div>
              <div className="reason">
                <span className="reason-text">Dedicated marketing</span>
                <span className="column-one">
                  <CheckCircle size={24} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={24} color="#822841" weight="fill" />
                </span>
              </div>
              <div className="reason">
                <span className="reason-text">3D home tour</span>
                <span className="column-one">
                  <CheckCircle size={24} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={24} color="#822841" weight="fill" />
                </span>
              </div>
              <div className="reason">
                <span className="reason-text">Video walkthrough</span>
                <span className="column-one">
                  <CheckCircle size={24} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={24} color="#822841" weight="fill" />
                </span>
              </div>
              <div className="reason">
                <span className="reason-text">Professional photos</span>
                <span className="column-one">
                  <CheckCircle size={24} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={24} color="#822841" weight="fill" />
                </span>
              </div>
            </article>
          </div>
          <div
            className={style.buttonContainer}
            style={{ justifyContent: 'center' }}
          >
            <Button
              variant="contained"
              className={`${style.largeButton} ${style.estimateButton}`}
              classes={{ label: classes.socialLabel }}
              size="large"
              onClick={() => {
                window.open(`${TYPEFORM_LINK}${utmParams}`, '_blank');
              }}
            >
              Get Estimate
            </Button>

            <Button
              variant="contained"
              className={`${style.largeButton} ${style.talkToUsButton}`}
              classes={{ label: classes.socialLabel }}
              size="large"
              onClick={() => {
                window.open(`${schedulingLink}${utmParams}`, '_blank');
              }}
            >
              Talk to us
              <CaretRight size={22} color="#195a50" weight="regular" />
            </Button>
          </div>
        </section>

        {/* Section Reviews */}
        <section className="col-xs-12 testimonials">
          <div className="blue-blob" />
          <div className="yellow-blob" />
          <Reviews
            autoSlide={true}
            title="Take their word for it"
            dontShowButtons={true}
          />
        </section>

        <section className="col-xs-12 video-container">
          <iframe
            width={isMobile() ? 750 : 750}
            height="420"
            src="https://www.youtube.com/embed/iWTcTFvf-yM?si=8nTZojKkQdFBUvlj"
            title="We Are Torii Homes"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </section>

        {/* Section Learn More */}
        <section className="col-xs-12 altImageText_block fullWidth_block pineGreen_bg">
          <div className="container_wrap">
            <div className="feature_block">
              <div className="row row-sell-page">
                <span className="sub-text" style={{ color: '#ffd750' }}>
                  Looking to buy a
                  <br className="no-tablet no-mobile" /> home?
                </span>
                <span className="text">
                  Work with a local Torii real estate agent through the entire
                  process, and we’ll set you up with a lender, closing services,
                  and everything else you’ll need. On top of that, we’ll give
                  you up to 10% of our commission back at close - how bout dat?
                </span>
                <div
                  className={style.buttonContainer}
                  style={{ textAlign: 'left' }}
                >
                  <Button
                    variant="contained"
                    className={`${style.largeButton} ${style.learnMoreButton}`}
                    classes={{ label: classes.socialLabel }}
                    size="large"
                    onClick={() => {
                      router.push('/buy');
                    }}
                  >
                    Learn More
                  </Button>
                </div>
              </div>
              <div className="image_wrap">
                <img
                  src={
                    isMobile()
                      ? '/static/img/landing_pages/sell-learnMore-mobile.png'
                      : '/static/img/landing_pages/sell-learnMore-desktop.png'
                  }
                  alt="cash offer"
                />
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const combinedStyles = combineStyles(buttonStyles, styles);
const mapStateToProps = (state: any) => ({
  utmCampaign: state.auth.utmCampaign,
  utmMedium: state.auth.utmMedium,
  utmSource: state.auth.utmSource,
  utmTerm: state.auth.utmTerm,
});

export default withStyles(combinedStyles)(connect(mapStateToProps)(SellPage));
